export default __webpack_public_path__ + "static/media/pictogramBeaconFeesAndInterest128.a4f66fce.svg";